import React, { useState, useEffect, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
// import { Helmet } from "react-helmet";
// Styles
import { useTheme } from "@mui/material/styles";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import {
  Grid,
  Box,
  Button,
  useMediaQuery,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
  TextField,
  Snackbar,
  Tooltip,
  Alert,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
// Assets
import { LogoItalmundo, DomicilioIcon, ItalmundoMapa } from "assets";
// Services
import PublicServices from "services/publicService";
import ClientService from "services/clientService";
import { grayColor } from "assets/jss/material-react";
import { useNavigate } from "react-router-dom";

function SolicitarMiTarjeta() {
  const navigate = useNavigate();

  //Inicializaciones base
  const clientService = new ClientService();
  const publicService = new PublicServices();
  const location = useLocation();
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);

  // Inicializaciones particulares
  const [cedula, setCedula] = useState("");
  const [pepChecked, setPepChecked] = useState(null);
  const [finChecked, setFinChecked] = useState(null);
  const [openSnack, setOpenSnack] = useState(false);
  const [textSnack, setTextSnack] = useState("");

  const message1 =
    "Personas políticamente expuestas son quienes cumplen o a quienes se les han confiado funciones públicas destacadas en los últimos 5 años.";
  const message2 =
    "Destinatario final son las personas que actúan a nombre propio, en este caso el titular del crédito.";

  const [allSucursales, setAllSucursales] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [allLocalidades, setAllLocalidades] = useState([]);
  const [localidadId, setLocalidadId] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [departamentoId, setDepartamentoId] = useState("");
  const [agenciaRetiroId, setAgenciaRetiroId] = useState("");
  const [errors, setErrors] = useState({});

  const documento = null;
  // const canonicalUrl = "";

  const getSucursales = async () => {
    const getAllSucursales = await publicService.getAgenciasRedPagos();
    const formattedSucursales = getAllSucursales.data.map((sucursal) => ({
      ...sucursal,
    }));
    setAllSucursales(formattedSucursales);
    return formattedSucursales;
  };

  const getLocalidades = (sucursales) => {
    const localidades = sucursales
      .map((suc) => ({
        localidadBarrio: suc.localidadBarrio,
        idLocalidad: suc.idLocalidad,
        idDepto: suc.idDepto,
      }))
      .filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idLocalidad === value.idLocalidad)
      )
      .sort((a, b) => a.localidadBarrio.localeCompare(b.localidadBarrio));
    setAllLocalidades(localidades);
  };

  const getDepartamentos = (sucursales) => {
    const departamentos = sucursales
      .map((suc) => ({
        departamento: suc.departamento,
        idDepto: suc.idDepto,
      }))
      .filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idDepto === value.idDepto)
      )
      .sort((a, b) => a.departamento.localeCompare(b.departamento));
    setDepartamentos(departamentos);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sucursales = await getSucursales();
        getLocalidades(sucursales);
        getDepartamentos(sucursales);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const openAlertSnack = (text) => {
    setOpenSnack(false);
    setTimeout(() => {
      setTextSnack(text);
      setOpenSnack(true);
    }, 50);
  };

  const handleCedulaChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 8) setCedula(value);
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    if (name === "idDepartamento") {
      const localidadesFiltradas = allLocalidades.filter(
        (x) => x.idDepto === value
      );
      setLocalidades(localidadesFiltradas);
      setDepartamentoId(value);
      setSucursales([]);
      setLocalidadId("");
      setAgenciaRetiroId("");
    }

    if (name === "idBarrio") {
      const sucursalesFiltradasPorBarrio = allSucursales.filter(
        (x) => x.idLocalidad === value
      );
      setAgenciaRetiroId("");
      setSucursales(sucursalesFiltradasPorBarrio);
      setLocalidadId(value);
    }

    if (name === "idAgenciaRetiro") {
      setAgenciaRetiroId(value);
    }
  };

  const handleValidation = () => {
    let valid = true;
    let newErrors = {};

    if (!pepChecked) {
      newErrors.check = "Debe responder estos campos";
      valid = false;
    } else if (finChecked !== "si") {
      newErrors.check = "Debe ser el destinatario final";
      valid = false;
    }

    if (!cedula) {
      newErrors.cedula = "Este campo es obligatorio";
      valid = false;
    }

    if (cedula.length !== 8) {
      newErrors.cedula = "Debe tener 8 digitos";
      valid = false;
    }

    if (!departamentoId) {
      newErrors.idDepartamento = "Este campo es obligatorio";
      valid = false;
    }

    if (!localidadId) {
      newErrors.idBarrio = "Este campo es obligatorio";
      valid = false;
    }

    if (!agenciaRetiroId) {
      newErrors.idAgenciaRetiro = "Este campo es obligatorio";
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  const handleSolicitarApi = async () => {
    if (!handleValidation()) {
      return;
    }
    setLoading(true);
    try {
      const selectAgencia = allSucursales.find(
        (x) => x.idAgenciaRedPagos === agenciaRetiroId
      );
      const responseAgency = await clientService.sendFormPeople({
        ci: cedula,
        department: selectAgencia.departamento,
        departmentId: departamentoId,
        locality: selectAgencia.localidadBarrio,
        localityId: localidadId,
        branch: selectAgencia.nombreAgenciaRedPagos,
        branchId: agenciaRetiroId,
        noPepConfirm: pepChecked === "si",
        finalRecipientConfirmed: finChecked === "si",
      });
      if (responseAgency.succeeded) {
        navigate("/gracias");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePep = (event) => {
    setPepChecked(event.target.value);
  };

  const handleChangeFin = (event) => {
    setFinChecked(event.target.value);
  };

  return (
    <>
      <Container
        maxWidth="md"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "center",
          padding: 0,
          paddingBottom: "1rem",
          backgroundImage: `url(${ItalmundoMapa})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <Helmet>
          <link rel="canonical" href={canonicalUrl} />
        </Helmet> */}
        <div className={classes.contentImageMobile}>
          <a
            href="https://italmundo.com.uy/"
            rel="noopener noreferrer"
            style={{
              width: "50%",
              maxWidth: "250px",
              maxHeight: "100%",
              paddingTop: "0.5rem",
              margin: mobile ? "2rem" : "3rem",
            }}
          >
            <img
              src={LogoItalmundo}
              alt="Home Mobile"
              style={{
                objectFit: "contain",
              }}
            />
          </a>
        </div>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "start",
              marginTop: "1rem",
              width: mobile ? "90%" : "100%",
            }}
          >
            <img
              src={DomicilioIcon}
              style={{
                marginRight: "8px",
                width: "24px",
                height: "24px",
              }}
            />
            <p
              style={{
                fontSize: mobile ? "12px" : "15px",
                fontWeight: "520",
              }}
            >
              ¿DÓNDE QUERÉS RETIRAR TU TARJETA?
            </p>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "start",
              marginTop: mobile ? "0.5rem" : "1rem",
              width: mobile ? "90%" : "100%",
            }}
          >
            <p
              style={{
                fontSize: mobile ? "12px" : "14px",
              }}
            >
              Retirá tu tarjeta en la sucursal de RedPagos más cercana a tu
              domicilio.
            </p>
          </Box>
          <Grid
            container
            spacing={mobile ? 0.5 : 3.5}
            sx={{ marginTop: "0.5rem" }}
          >
            <Grid item xs={12} sm={6} display="flex">
              <TextField
                id="cedula"
                name="cedula"
                label="Ingresá tu cédula*"
                variant="filled"
                fullWidth
                value={cedula}
                onChange={handleCedulaChange}
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  maxLength: 8,
                }}
                error={!!errors.cedula}
                helpertext={errors.cedula}
                className={classes.formControlCustom}
                sx={{
                  margin: "auto",
                  width: mobile ? "90%" : "100%",
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} display="flex">
              <FormControl
                fullWidth
                variant="filled"
                error={!!errors.idDepartamento}
                helpertext={errors.idDepartamento}
                className={classes.formControlCustom}
                sx={{
                  margin: "auto",
                  width: mobile ? "90%" : "100%",
                }}
              >
                <InputLabel id="departamento-label">Departamento*</InputLabel>
                <Select
                  labelId="departamento-label"
                  id="idDepartamento"
                  name="idDepartamento"
                  onChange={handleInputChange}
                  label="Departamento*"
                  value={departamentoId}
                  className={classes.inputCustom}
                  sx={{
                    "& .MuiMenuItem-root": {
                      boxShadow: "none",
                    },
                    "& .MuiPaper-root": {
                      border: "1px solid #d3d4d5",
                    },
                    "&:after": {
                      borderBottom: "2px solid rgb(4 128 143)",
                    },
                  }}
                >
                  {departamentos.map((depto) => (
                    <MenuItem key={depto.idDepto} value={depto.idDepto}>
                      {depto.departamento}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} display="flex">
              <FormControl
                fullWidth
                variant="filled"
                className={classes.formControlCustom}
                error={!!errors.idBarrio}
                sx={{
                  margin: "auto",
                  width: mobile ? "90%" : "100%",
                }}
              >
                <InputLabel id="barrio-label">Barrio/Localidad*</InputLabel>
                <Select
                  labelId="barrio-label"
                  id="idBarrio"
                  name="idBarrio"
                  onChange={handleInputChange}
                  label="Barrio*"
                  className={classes.inputCustom}
                  value={localidadId}
                  sx={{
                    "& .MuiMenuItem-root": {
                      boxShadow: "none",
                    },
                    "& .MuiPaper-root": {
                      border: "1px solid #d3d4d5",
                    },
                    "&:after": {
                      borderBottom: "2px solid rgb(4 128 143)",
                    },
                  }}
                >
                  {departamentoId ? (
                    localidades.map((localidad) => (
                      <MenuItem
                        key={localidad.idLocalidad}
                        value={localidad.idLocalidad}
                      >
                        {localidad.localidadBarrio}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={0} value={0}>
                      Seleccione un departamento
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} display="flex">
              <FormControl
                fullWidth
                variant="filled"
                className={classes.formControlCustom}
                error={!!errors.idAgenciaRetiro}
                sx={{
                  margin: "auto",
                  width: mobile ? "90%" : "100%",
                }}
              >
                <InputLabel id="sucursal-label">Sucursal*</InputLabel>
                <Select
                  labelId="sucursal-label"
                  id="idAgenciaRetiro"
                  name="idAgenciaRetiro"
                  className={classes.inputCustom}
                  value={agenciaRetiroId}
                  onChange={handleInputChange}
                  label="Sucursal*"
                  sx={{
                    "& .MuiMenuItem-root": {
                      boxShadow: "none",
                    },
                    "& .MuiPaper-root": {
                      border: "1px solid #d3d4d5",
                    },
                    "&:after": {
                      borderBottom: "2px solid rgb(4 128 143)",
                    },
                  }}
                >
                  {sucursales.length > 0 ? (
                    sucursales.map((sucursal) => (
                      <MenuItem
                        key={sucursal.idAgenciaRedPagos}
                        value={sucursal.idAgenciaRedPagos}
                      >
                        <p>
                          {sucursal.nombreAgenciaRedPagos}
                          <br />
                          <small> {sucursal.direccionAgenciaRedPagos}</small>
                        </p>
                      </MenuItem>
                    ))
                  ) : localidadId !== "" ? (
                    <MenuItem key={0} value={0}>
                      No hay sucursales
                    </MenuItem>
                  ) : (
                    <MenuItem key={0} value={0}>
                      Seleccione departamento y localidad
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: mobile ? "90%" : "100%",
            }}
          >
            <p
              style={{
                fontSize: "11px",
                lineHeight: "1.2",
                width: "100%",
                textAlign: "left",
                marginTop: "1rem",
              }}
            >
              *Todos los campos son obligatorios.
            </p>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: mobile ? "90%" : "100%",
              marginTop: mobile ? "1rem" : "2rem",
            }}
          >
            <Box
              display="flex"
              flexDirection={mobile ? "column" : "row"}
              alignItems={mobile ? "flex-start" : "center"}
            >
              <Tooltip title={message1} disableHoverListener={mobile}>
                <p
                  style={{
                    fontSize: "14px",
                    color: grayColor,
                    margin: 0,
                    cursor: "pointer",
                    marginRight: mobile ? "0" : "30px",
                  }}
                  onClick={() => {
                    if (mobile) openAlertSnack(message1);
                  }}
                >
                  Indique si es una persona políticamente expuesta.
                </p>
              </Tooltip>

              <RadioGroup
                row
                name="pep-check"
                value={pepChecked}
                onChange={handleChangePep}
              >
                <FormControlLabel
                  value="si"
                  label="Sí"
                  sx={{ color: "#9b9b9b" }}
                  control={
                    <Radio
                      sx={{
                        color: "#39BCC4",
                        "&.Mui-checked": { color: "#39BCC4" },
                      }}
                    />
                  }
                />
                <FormControlLabel
                  value="no"
                  label="No"
                  sx={{ color: "#9b9b9b" }}
                  control={
                    <Radio
                      sx={{
                        color: "#39BCC4",
                        "&.Mui-checked": { color: "#39BCC4" },
                      }}
                    />
                  }
                />
              </RadioGroup>
            </Box>

            <Box
              display="flex"
              flexDirection={mobile ? "column" : "row"}
              alignItems={mobile ? "flex-start" : "center"}
            >
              <Tooltip title={message2} disableHoverListener={mobile}>
                <p
                  style={{
                    fontSize: "14px",
                    color: grayColor,
                    margin: 0,
                    cursor: "pointer",
                    marginRight: mobile ? "0" : "30px",
                  }}
                  onClick={() => {
                    if (mobile) openAlertSnack(message2);
                  }}
                >
                  Indique si es destinatario final.
                </p>
              </Tooltip>

              <RadioGroup
                row
                name="fin-check"
                value={finChecked}
                onChange={handleChangeFin}
              >
                <FormControlLabel
                  value="si"
                  label="Sí"
                  sx={{ color: "#9b9b9b" }}
                  control={
                    <Radio
                      sx={{
                        color: "#39BCC4",
                        "&.Mui-checked": { color: "#39BCC4" },
                      }}
                    />
                  }
                />
                <FormControlLabel
                  value="no"
                  label="No"
                  sx={{ color: "#9b9b9b" }}
                  control={
                    <Radio
                      sx={{
                        color: "#39BCC4",
                        "&.Mui-checked": { color: "#39BCC4" },
                      }}
                    />
                  }
                />
              </RadioGroup>
            </Box>
            {errors.check ? (
              <p
                style={{
                  fontSize: "11px",
                  marginTop: "0.2rem",
                  color: "red",
                  margin: 0,
                }}
              >
                {errors.check}
              </p>
            ) : null}
          </Box>

          <Snackbar
            open={openSnack}
            autoHideDuration={5000}
            onClose={() => setOpenSnack(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert severity="info" sx={{ width: "100%" }}>
              {textSnack}
            </Alert>
          </Snackbar>

          {mobile ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                marginTop: "2rem",
                width: "90%",
              }}
            >
              <Button
                className={`${classes.btnFull} ${classes.btnAzul}`}
                variant="text"
                disabled={loading}
                onClick={handleSolicitarApi}
                sx={{
                  width: "100%",
                  backgroundColor: "#FFFF",
                }}
              >
                Coordinar ahora
              </Button>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                marginTop: "2rem",
                width: "100%",
              }}
            >
              <p
                style={{
                  fontSize: mobile ? "12px" : "15px",
                  paddingRight: "1rem",
                  fontWeight: "420",
                  letterSpacing: "2px",
                }}
              >
                COORDINAR AHORA
              </p>
              <Button
                className={`${classes.btnSmall} ${classes.btnAzul}`}
                variant="text"
                disabled={loading}
                onClick={handleSolicitarApi}
                sx={{
                  width: "100%",
                  backgroundColor: "#FFFF",
                }}
              >
                <ArrowRightAltIcon />
              </Button>
            </Box>
          )}
        </Box>
      </Container>
      {loading && (
        <Box className={classes.overlay}>
          <CircularProgress sx={{ color: "#C4C4C4" }} />
        </Box>
      )}
    </>
  );
}

export default SolicitarMiTarjeta;
